import { Component, OnDestroy } from '@angular/core';
import {
  LMUploadStatus,
  LMXLFileUploadService,
  LMXLFileUploadStatus
} from '@services/file-upload/lm-xlfile-upload.service';
import { LMFormatUtilService } from '@app/services';
import { LMGlobalPersonalizationService } from '@app/states';
import { SubscriptionLike as ISubscription } from 'rxjs';

@Component({
  selector: 'lm-xlfile-upload-progress',
  standalone: false,
  templateUrl: './lm-xlfile-upload-progress.component.html',
  styleUrls: [ './lm-xlfile-upload-progress.component.scss' ]
})

export class LMXLFileUploadProgressComponent implements OnDestroy {
  public statusMessage = '';
  public allFilesUploadStatus:LMXLFileUploadStatus[] = [];
  // public useCompactFormLayout = false;
  private uploadStatusSubscription!: ISubscription;

  constructor(
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private lmXLFileUploadService: LMXLFileUploadService,
    private lmFormatUtilService: LMFormatUtilService) {
    // this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout;
      this.initialize();
  }

  ngOnDestroy() {
    if (this.uploadStatusSubscription) {
      this.uploadStatusSubscription.unsubscribe();
    }
  }

  private initialize() {
    this.getCurrentStatus();
    this.uploadStatusSubscription = this.lmXLFileUploadService.xlFileUploadStatusSubject.subscribe(() => {
      this.getCurrentStatus();
    });
  }

  private getCurrentStatus() {
    this.allFilesUploadStatus = Object.values(this.lmXLFileUploadService.xlfileUploadStatus);
    const total = this.allFilesUploadStatus.length;
    const uploaded = this.allFilesUploadStatus.filter(f => f.status === LMUploadStatus.COMPLETED).length;

    this.statusMessage = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('FilesUploadedStatus'), [ uploaded, total ]);
  }
}
